/*
   storehero-ig-live.js
   /pages/ig-live の「Voices（お客様の声）」を横一列の自動スクロールにする。

   来歴: 元は templates/page.insta-live.json の Custom Liquid セクション
   （custom_liquid_qUH3g7）の <script> に埋め込まれていた。2026-08-22 の事故
   （sections/custom-liquid.liquid の上書き）を受けて本ファイルへ移設した（2026-08-27）。

   移設時に直した点:
   1. list.innerHTML += list.innerHTML でノードを丸ごと作り直していた
      → cloneNode に変更（イベントリスナと画像の再読み込みが起きない）
   2. 1周ぶんの移動量を translateX(-50%) 固定にしていたため、カード間の余白ぶんだけずれ、
      一周ごとに継ぎ目が飛んでいた
      → 移動量の計算は storehero-ig-live.css へ移した。JS はカードの枚数だけを渡す。
        枚数は画面幅で変わらないので、resize を監視する必要がない。

   読み込み: layout/theme.liquid で template.suffix == 'insta-live' のときだけ defer 読み込み。
*/
(function () {
  'use strict';

  function setup() {
    var list = document.querySelector('.promotion-block-list');
    if (!list || list.dataset.voices) return;

    var originalCount = list.children.length;
    if (originalCount === 0) return;

    list.dataset.voices = '1';

    // 無限ループ用に同じ並びをもう1セット複製する
    var fragment = document.createDocumentFragment();
    for (var i = 0; i < originalCount; i++) {
      fragment.appendChild(list.children[i].cloneNode(true));
    }
    list.appendChild(fragment);

    var container = list.closest('.container');
    if (container) container.classList.add('voices-viewport');

    // 1周ぶんの移動量は CSS 側が --voices-count から算出する
    list.style.setProperty('--voices-count', String(originalCount));
    list.classList.add('is-voices-scrolling');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
